import { LocalStorage } from 'quasar';
import constants from 'src/common/constants';

export function isAuthenticated(state) {
  return state.account !== null;
}

export function findAccountById(state) {
  return (id) => state.accounts.find(((v) => v.id === id));
}

export function hasCredentials() {
  return LocalStorage.has(constants.LOCALSTORAGE_ACCESS_TOKEN);
}

export function isNotificationUser(state) {
  return state.account?.role?.role === 'notification';
}
